@if (activity && activity.comments?.length > 0) {
  <div class="timeline-comments">
    @for (comment of activity.comments; track comment) {
      <div class="timeline-comments-comment">
        <div class="timeline-comment-header">
          <a href="mailto:{{ comment.createur.email }}">
            {{ comment.createur.prenom }} {{ comment.createur.nom }}
          </a>, le {{ comment.dateCreation | date :'dd/MM/yyyy à HH:mm'  }}
          @if (comment.dateModification) {
            ( modifié le {{ comment.dateModification | date :'dd/MM/yyyy à HH:mm'  }})
          }
        </div>
        @if (comment['isMine']) {
          <a class="timeline-comment-edit" (click)="editComment(comment)"  href="javascript:void(0)">
            <mat-icon>edit</mat-icon>
          </a>
        }
        <div class="timeline-comment-content">
          @if (!comment['editing']) {
            {{ comment.commentaire }}
          }
          @if (isAdmin && comment['editing']) {
            <app-log-comment-box
              [activity]="activity"
              [comment]="comment"
              (commentPosted)="comment['editing'] = false"
              >
            </app-log-comment-box>
          }
        </div>
      </div>
    }
  </div>
}

@if (activity && isAdmin && (activity.comments?.length > 0 || showCommentBox) && !hideCommentBox) {
  <app-log-comment-box
    [activity]="activity"
    (commentPosted)="activity.comments.push($event)"
    >
  </app-log-comment-box>
}
